/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class ChatnotesDialog extends NoboxEntityDialog<ChatnotesRow, any> {
        protected getFormKey() { return ChatnotesForm.formKey; }
        protected getIdProperty() { return ChatnotesRow.idProperty; }
        protected getLocalTextPrefix() { return ChatnotesRow.localTextPrefix; }
        protected getNameProperty() { return ChatnotesRow.nameProperty; }
        protected getService() { return ChatnotesService.baseUrl; }
        protected getDeletePermission() { return ChatnotesRow.deletePermission; }
        protected getInsertPermission() { return ChatnotesRow.insertPermission; }
        protected getUpdatePermission() { return ChatnotesRow.updatePermission; }

        protected form = new ChatnotesForm(this.idPrefix);
        public userLogin: any;
        public ObjAccount: any;
        public ObjLink: any;
        public callback = (data) => {

        }
        protected getToolbarButtons() {
            var btn = super.getToolbarButtons();
            btn[2].visible = false;
            return btn;
        }
        public valNt = '';
        protected save() {
            this.valNt = this.form.Cnt.value;
            super.save();
        }

        protected onSaveSuccess(response) {
            super.onSaveSuccess(response);
            var objNote = {
                Id: response.EntityId,
                Cnt: this.valNt,
                Mode:"Add"
            };
            if (!this.isNew())
                objNote.Mode = "Edit";

            this.callback(objNote);

            Serenity.SubDialogHelper.triggerDataChange(this);   // *** Refreshing the parent grid ***
            this.dialogClose();    // *** Closing the dialog ***
        }
    }
}